import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import NewsRightSideBar from '../News/NewsRightSideBar';
import config from '../../../config/config.json';

const New = ({ lang, match }) => {
    const [noticia, setNoticia] = useState({})

    useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    useEffect(() => {
        let url = `${config.apiBaseUrl}/noticia/${match.params.slug}`;

        // obteniendo las noticias
        fetch(url)
            .then(
                res => {
                    return res.json();
                }
            )
            .then(
                data => {
                    console.log('noticia => ', data);
                    setNoticia(data);
                }
            )
            .catch(
                err => {
                    console.log("new error ", err);
                }
            );

        // cleanup
        return () => {
        }
    }, []);


    return (
        <div class="main" style={{ paddingTop: 100 }}>
            <div class="container">
                <ul class="breadcrumb">
                    <li><Link to="/home">Inicio</Link></li>
                    <li><Link to="/news">Noticias</Link></li>
                    <li class="active">{noticia.titulo}</li>
                </ul>
                {/* BEGIN SIDEBAR & CONTENT */}
                <div class="row margin-bottom-40">
                    {/* BEGIN CONTENT */}
                    <div class="col-md-12 col-sm-12">
                        <h1>{noticia.titulo}</h1>
                        <div class="content-page">
                            <div class="row">
                                {/* BEGIN LEFT SIDEBAR */}
                                <div class="col-md-9 col-sm-9 blog-item">
                                    <div class="blog-item-img">
                                        <img src={noticia.foto} alt={noticia.titulo} />
                                    </div>
                                    {/* <h2><a href="javascript:;">Corrupti quos dolores etquas</a></h2> */}
                                    {noticia.texto}
                                    <ul class="blog-info">
                                        <li><i class="fa fa-user"></i> {noticia.autor}</li>
                                        <li><i class="fa fa-calendar"></i> {noticia.fecha}</li>
                                        <li><i class="fa fa-comments"></i> 0</li>
                                        <li><i class="fa fa-tags"></i> Sin Etiquetas</li>
                                    </ul>

                                    {/* <h2>Commentarios</h2>
                                    <div class="comments">
                                        <div class="media">
                                            <a href="javascript:;" class="pull-left">
                                                <img src="../../assets/frontend/pages/img/people/img1-small.jpg" alt="" class="media-object" />
                                            </a>
                                            <div class="media-body">
                                                <h4 class="media-heading">Media heading <span>5 hours ago / <a href="javascript:;">Reply</a></span></h4>
                                                <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
                                                {/* Nested media object /}
                                                <div class="media">
                                                    <a href="javascript:;" class="pull-left">
                                                        <img src="../../assets/frontend/pages/img/people/img2-small.jpg" alt="" class="media-object" />
                                                    </a>
                                                    <div class="media-body">
                                                        <h4 class="media-heading">Media heading <span>17 hours ago / <a href="javascript:;">Reply</a></span></h4>
                                                        <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
                                                    </div>
                                                </div>
                                                {/*end media/}
                                                <div class="media">
                                                    <a href="javascript:;" class="pull-left">
                                                        <img src="../../assets/frontend/pages/img/people/img3-small.jpg" alt="" class="media-object" />
                                                    </a>
                                                    <div class="media-body">
                                                        <h4 class="media-heading">Media heading <span>2 days ago / <a href="javascript:;">Reply</a></span></h4>
                                                        <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
                                                    </div>
                                                </div>
                                                {/*end media/}
                                            </div>
                                        </div>
                                        {/*end media/}
                                        <div class="media">
                                            <a href="javascript:;" class="pull-left">
                                                <img src="../../assets/frontend/pages/img/people/img4-small.jpg" alt="" class="media-object" />
                                            </a>
                                            <div class="media-body">
                                                <h4 class="media-heading">Media heading <span>July 25,2013 / <a href="javascript:;">Reply</a></span></h4>
                                                <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
                                            </div>
                                        </div>
                                        {/*end media/}
                                    </div>

                                    <div class="post-comment padding-top-40">
                                        <h3>Leave a Comment</h3>
                                        <form role="form">
                                            <div class="form-group">
                                                <label>Name</label>
                                                <input class="form-control" type="text" />
                                            </div>

                                            <div class="form-group">
                                                <label>Email <span class="color-red">*</span></label>
                                                <input class="form-control" type="text" />
                                            </div>

                                            <div class="form-group">
                                                <label>Message</label>
                                                <textarea class="form-control" rows="8"></textarea>
                                            </div>
                                            <p><button class="btn btn-primary" type="submit">Post a Comment</button></p>
                                        </form>
                                    </div> */}
                                </div>
                                {/* END LEFT SIDEBAR */}

                                {/* BEGIN RIGHT SIDEBAR */}
                                <NewsRightSideBar />
                                {/* END RIGHT SIDEBAR */}
                            </div>
                        </div>
                    </div>
                    {/* END CONTENT */}
                </div>
                {/* END SIDEBAR & CONTENT */}
            </div>
        </div>
    );
}

export default withRouter(New);